// extracted by mini-css-extract-plugin
export default {"contactTable":"SingleContact_contactTable__f1Z0P","propertyColumn":"SingleContact_propertyColumn__NtoEZ"};